import {ToastNotificationServiceName} from "modules/utils/names/serviceNames";
import {ToastNotificationService} from "modules/utils/ToastNotificationService";

export class SmsClarificationDialog {

    public static instance = ({
        template: require("./clarification.html"),
        controller: [
            '$mdDialog',
            ToastNotificationServiceName,
            SmsClarificationDialog
        ],
        controllerAs: '$ctrl',
        clickOutsideToClose: true,
        multiple: true
    })

    constructor(
        private $mdDialog: angular.material.IDialogService,
        private toastService: ToastNotificationService
    ) {}

    public chooseMethod(method: 'DIRECT_SMS' | 'EXTERNAL_SMS') {
        this.$mdDialog.hide(method);
    }

}
